export const getCurrencyRoute = (currency) => {
  return `/currency/${currency.tag}`
}
